<template>
    <el-menu
    :default-active="activeIndex"
    class="el-menu-demo horizontal-bar border-0"
    mode="horizontal"
    :ellipsis="false"
    @select="handleSelect"
    >
    
    <el-menu-item index="0" @click="toggleSideBar">
        <i class="fa-sharp fa-solid fa-bars" style="font-size: 20px"></i>
    </el-menu-item>
    <div class="flex-grow-1" tabindex="0"></div>
    <el-sub-menu index="1" style="background-color: #FAFAFD">
      <template #title>
        <div class="d-flex text-secondary align-items-center">
          <img :src="userIcon" style="height: 45px;" class="me-2"/>
          <div style="line-height: 1px;">
            <p class="fw-bold">{{ sessionName }}</p>
            <span class="text-muted" style="font-size: 12px">{{ currentUserSession }}</span>
          </div>
        </div>
      </template>
      <el-menu-item index="2-1" @click="logoutUser()">
        <i class="fa-sharp-duotone fa-solid fa-left-from-bracket me-2" aria-hidden="true"></i> Logout
      </el-menu-item>
      <!-- <el-menu-item index="2-1" @click="redirectToPage('/dashboard/password-reset')" v-if="showPasswordReset">
        <i class="fa-sharp-duotone fa-solid fa-lock me-2"></i> Reset Password
      </el-menu-item> -->
    </el-sub-menu>
    <!-- <el-sub-menu index="2">
        <template #title>Workspace</template>
            <el-menu-item index="2-1">item one</el-menu-item>
            <el-menu-item index="2-2">item two</el-menu-item>
            <el-menu-item index="2-3">item three</el-menu-item>
        <el-sub-menu index="2-4">
        <template #title>item four</template>
            <el-menu-item index="2-4-1">item one</el-menu-item>
            <el-menu-item index="2-4-2">item two</el-menu-item>
            <el-menu-item index="2-4-3">item three</el-menu-item>
        </el-sub-menu>
    </el-sub-menu> -->
    </el-menu>
</template>

<script lang="js">
import store from '../store'
import { mapState } from 'vuex'
import Mixin from '../mixins/global.mixin'
import userIcon from '../assets/circle-user-duotone-solid.svg'
import userIconDark from '../assets/circle-user-duotone-solid-dark.svg'

export default {
  name: 'HeaderComponent',
  mixins: [Mixin],
  computed: mapState([
    'isCollapse',
    'currentSessionFirstname',
    'currentSessionLastname',
    'currentSessionEmail',
    'currentUserSession',
    'currentSessionRailsID'
  ]),
  watch: {
    currentSessionFirstname: function () {
      this.updateUserName();
    },
    currentSessionRailsID: function (newVal) {
      if (newVal) {
        this.showPasswordReset = false;
      } else {
        this.showPasswordReset = false;
      }
      
    }
  },
  setup() {
    return {
      userIcon: userIcon,
      userIconDark: userIconDark
    }
  },
  data() {
    return {
      sessionName: null,
      showPasswordReset: false,
    }
  },
  methods: {
    toggleSideBar: function () {
      store.commit('SET_SIDEBAR_TOGGLE', !this.isCollapse);
    },
    updateUserName: function () {
      this.sessionName = (this.currentSessionFirstname && this.currentSessionLastname) ? this.currentSessionFirstname + ' ' + this.currentSessionLastname : this.currentSessionEmail;
    },

  },
  mounted() {
    this.updateUserName();
  }
}
</script>